import { Guid, Nillable } from '@web/utils';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

export type WarehouseReleaseControls = {
  releasedAt: FormControl<Date>;
  comment: FormControl<Nillable<string>>;
  products: FormArray<WarehouseReleaseProductFormGroup>;
  fileIds: FormControl<Nillable<Guid[]>>;
};

export type WarehouseReleaseProductControls = {
  id: FormControl<Nillable<Guid>>;
  quantity: FormControl<Nillable<number>>;
};

export class WarehouseReleaseFormData {
  public static readonly MaxCommentLength = 50000;

  public constructor(
    private data: {
      comment?: Nillable<string>;
      releasedAt: Date;
      products: WarehouseReleaseProductFormData[];
      fileIds?: Nillable<Guid[]>;
    },
  ) {}

  public get releasedAt(): Date {
    return this.data.releasedAt;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get products(): WarehouseReleaseProductFormData[] {
    return this.data.products;
  }

  public get fileIds(): Nillable<Guid[]> {
    return this.data.fileIds;
  }
}

export class WarehouseReleaseProductFormData {
  public constructor(
    private data: {
      id?: Nillable<Guid>;
      productId: Guid;
      quantity: number;
    },
  ) {}

  public get id(): Nillable<Guid> {
    return this.data.id;
  }

  public get productId(): Guid {
    return this.data.productId;
  }

  public get quantity(): number {
    return this.data.quantity;
  }
}

/* prettier-ignore */
export type WarehouseReleaseFormGroup = FormGroup<WarehouseReleaseControls>;

/* prettier-ignore */
export type WarehouseReleaseProductFormGroup = FormGroup<WarehouseReleaseProductControls>;
